













import { Component, Prop, Vue } from 'vue-property-decorator';
import * as StringUtil from '@/common/StringUtil';

import SerialCodeParam from '@/models/coupon/SerialCodeParam';

@Component
export default class SerialCodeCheckbox extends Vue {
  private SerialCodeParam = new SerialCodeParam();

  private isChecked = false;

  @Prop({ required: true })
  value!: string

  /**
   * シリアルコード入力チェック（入力がない場合、申し込み不可）
   */
  private inputCheck() {
    this.SerialCodeParam.serialCode = this.value;
    if (!StringUtil.isEmpty(this.SerialCodeParam.serialCode)) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
  }
}
